module.exports = __webpack_public_path__ + "img/newlogo.03ea971f.png";